module.exports = __webpack_public_path__ + "5dbad14f458e1cb950a582ad2c710ff5.svg";